import { FETCH_ANALYTICS_API } from "../helpers/api-path";
import httpClient from "./http.interceptor";

/**
 * Common function to fetch insight data by type
 * @param {Object} formData - The data to send in the POST body
 * @param {string} insightType - Type from INSIGHT_PAGE (e.g., CONVERSATION, CAMPAIGN, COMPANY)
 * @returns {Promise} - API response
 */
const getInsightDataAPI = async (formData) => {
  return await httpClient.post(FETCH_ANALYTICS_API, {
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
    ...formData,
  });
};

export {
    getInsightDataAPI
}